/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Processes_AnswerInputs */

const en_faq_processes_answer = /** @type {(inputs: Faq_Processes_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systems for work that repeats (customer questions, email triage, document processing, CRM updates, reports and team handoffs), systems that find, research and follow up leads, AI agent teams with roles and budgets, research agents that cite their sources, and complete AI systems run end to end. We start with a scoped first phase and expand once it works.`)
};

const lv_faq_processes_answer = /** @type {(inputs: Faq_Processes_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēmas darbiem, kas atkārtojas (klientu jautājumi, e-pasta šķirošana, dokumentu apstrāde, CRM atjaunināšana, atskaites un darba nodošana komandā), sistēmas, kas atrod, izpēta un apstrādā potenciālos klientus, AI aģentu komandas ar lomām un budžetiem, izpētes aģentus, kas norāda avotus, un pilnas AI sistēmas, ko uzturam no sākuma līdz beigām. Sākam ar skaidri noteiktu pirmo posmu un paplašinām, kad tas strādā.`)
};

/**
* | output |
* | --- |
* | "Systems for work that repeats (customer questions, email triage, document processing, CRM updates, reports and team handoffs), systems that find, research an..." |
*
* @param {Faq_Processes_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_processes_answer = /** @type {((inputs?: Faq_Processes_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Processes_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_processes_answer(inputs)
	return en_faq_processes_answer(inputs)
});